
export const de = {
    nav: {
        dashboard: "Dashboard",
        playlists: "Playlists",
        users: "Benutzer",
        settings: "Einstellungen",
        churches: "Gemeinden",
        logout: "Abmelden",
        darkMode: "Dunkelmodus",
        lightMode: "Hellmodus",
        profile: "Profil",
        general: "Allgemein",
        collapse: "Menü einklappen",
        expand: "Menü ausklappen",
        simulating: "Benutzer simulieren",
        stopSimulating: "Simulation beenden",
        material: "Material",
        worship: "Lobpreis",
        cloudFiles: "Material",
        logs: "System LogView",
        devices: "Geräte"
    },
    dashboard: {
        welcome: "Willkommen zurück,",
        stats: "",
        nextEvent: "Nächstes Event",
        nextSunday: "Nächster Gottesdienst",
        activeUsers: "Aktive Benutzer",
        startPresentation: "Präsentation starten",
        noUpcomingEvents: "Keine bevorstehenden Events",
        manageUsers: "Benutzer",
        viewAll: "Alle anzeigen",
        allPlaylists: "Alle Playlists",
        upcomingPlaylists: "Kommende Playlisten",
        playlistCount: "{{count}} Playliste",
        playlistCount_plural: "{{count}} Playlisten",
        noUpcomingPlaylists: "Noch keine kommenden Playlists",
        createFirstPlaylist: "Erstelle deine erste Playlist, um die Gottesdienstabläufe deiner Gemeinde zu verwalten.",
        noPlaylists: "Noch keine Playlists",
        createFirst: "Erstelle deine erste Playlist",
        totalMediaElementsWithChurchId: "Lobpreislieder",
        totalMaterialFiles: "Gesamt Materialdateien"
    },
    login: {
        title: "Bei ChurchCast anmelden",
        email: "E-Mail Adresse",
        password: "Passwort",
        submit: "Anmelden",
        forgotPassword: "Passwort vergessen?",
        backToLogin: "Zurück zur Anmeldung",
        backToWebsite: "Zurück zur Website",
        resetTitle: "Passwort zurücksetzen",
        resetDesc: "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.",
        sendLink: "Link senden",
        linkSent: "Link gesendet!",
        linkSentDesc: "Überprüfen Sie Ihren Posteingang für weitere Anweisungen.",
        error: "Ungültige Anmeldedaten.",
        setNewPassword: "Neues Passwort setzen",
        success: "Erfolgreich!",
        newPassword: "Neues Passwort",
        confirmPassword: "Neues Passwort bestätigen",
        resetPassword: "Passwort zurücksetzen",
        backToLoginShort: "Zurück zur Anmeldung",
        errors: {
            invalidEmail: "Benutzerkonto nicht gefunden.",
            invalidPassword: "Das eingegebene Passwort ist falsch.",
            generic: "Ein unerwarteter Fehler ist aufgetreten."
        },
        errorOccurred: "Ein Fehler ist aufgetreten",
        networkError: "Netzwerkfehler. Bitte versuchen Sie es erneut.",
        passwordsNoMatch: "Passwörter stimmen nicht überein",
        passwordTooShort: "Passwort muss mindestens 6 Zeichen lang sein",
        enterEmail: "Geben Sie Ihre E-Mail-Adresse ein",
        enterNewPassword: "Neues Passwort eingeben",
        confirmNewPassword: "Neues Passwort bestätigen"
    },
    media: {
        title: "Material",
        tabs: {
            files: "Material",
            youtube: "YouTube Bibliothek"
        },
        upload: "Datei hochladen",
        newFolder: "Neuer Ordner",
        addVideo: "Video hinzufügen",
        addPlaylist: "Playlist hinzufügen",
        videoUrl: "YouTube Video URL",
        playlistId: "Playlist ID",
        empty: "Keine Medienelemente gefunden.",
        filesDesc: "Verwalten Sie Dateien von Ihrem verbundenen Cloud-Speicher.",
        youtubeDesc: "Verwalten Sie die Sammlung von YouTube-Ressourcen für Playlists.",
        sidbarTitle: "Erkannte Medien",
        dropZone: "Dateien hier ablegen",
        uploading: "Wird hochgeladen",
        uploadComplete: "Upload abgeschlossen",
        searchMedia: "Dateien und Videos suchen...",
        songs: "Lieder",
        confirmDeletePlaylist: "Sind Sie sicher, dass Sie diese Playlist löschen möchten? Alle Videos aus dieser Playlist werden entfernt.",
        cannotDeletePlaylistVideo: "Video aus einer YouTube-Playlist kann nicht gelöscht werden. Löschen Sie stattdessen die Playlist.",
        fromPlaylist: "Aus Playlist",
        playlists: "Playlists",
        videos: "Videos",
        tracks: "Titel",
        refresh: "Aktualisieren",
        latestVideos: "Neueste Videos",
        latestTracks: "Neueste Titel",
        moreVideos: "weitere Videos",
        moreTracks: "weitere Titel",
        collapse: "Einklappen",
        expand: "Ausklappen",
        addFromUrlTitle: "Von URL hinzufügen",
        addFromUrlPlaceholder: "Video, Playliste oder Spotify hinzufügen",
        addFromUrlDesc: "Fügen Sie eine beliebige URL ein. Die App erkennt, ob es sich um ein einzelnes Video, einen Song oder eine Playlist handelt.",
        adding: "Hinzufügen...",
        add: "Hinzufügen",
        openInYoutube: "In YouTube öffnen",
        addToPlaylist: "Zu Playlist hinzufügen",
        selectPlaylist: "Playlist auswählen",
        nextSunday: "Nächste Gottesdienste",
        errorTitle: "Fehler",
        convertToSlides: "In Folien umwandeln",
        converting: "PDF wird umgewandelt...",
        conversionComplete: "Folien erstellt!",
        createNewPlaylist: "Neue Playlist erstellen",
        playlistName: "Playlist Name",
        existingPlaylists: "Bestehende Playlists",
        noPlaylists: "Keine Playlists verfügbar",
        items: "Elemente",
        playlistCreated: "Playlist erfolgreich erstellt!",
        searchPlaylists: "Playlists suchen...",
        selectImages: "Bilder importieren",
        sort: {
            title: "Sortieren",
            alphabetical: "Alphabetisch",
            date: "Hinzugefügt am",
            duration: "Dauer",
            type: "Typ",
            ascending: "Aufsteigend",
            descending: "Absteigend"
        },
        filter: {
            all: "Alle",
            youtube: "YouTube",
            spotify: "Spotify"
        },
        search: {
            resultsFor: "Suchergebnisse für:",
            clear: "Löschen",
            noResults: "Keine Dateien gefunden für",
            searching: "Suchen...",
            inSubfolders: "Suche in Unterordnern"
        },
        // New media translations
        missingFileOrChurchId: "Fehlende Datei-ID oder Kirchen-ID",
        failedFetchFile: "Datei konnte nicht abgerufen werden: {status} {statusText}",
        audioFile: "audio.mp3",
        loadingAudio: "Audio wird geladen...",
        errorLoadingAudio: "Fehler beim Laden des Audios",
        audioViewerError: "Audio-Viewer Fehler",
        audioNotDisplayed: "Das Audio konnte nicht im Browser angezeigt werden.",
        browserCompatibility: "Dies könnte an Browser-Kompatibilität oder Audio-Format-Problemen liegen.",
        downloadAudio: "Audio herunterladen",
        noFileData: "Keine Dateidaten verfügbar",
        failedLoadAudio: "Audio konnte nicht geladen werden",
        download: "Herunterladen",
        closeEsc: "Schließen (ESC)",
        unknownTrack: "Unbekannter Titel",
        unknownArtist: "Unbekannter Künstler",
        dragPlayer: "Player ziehen",
        openFullScreen: "Vollbild öffnen",
        close: "Schließen",
        invalidSpotifyUrl: "Ungültige Spotify-URL",
        pdfDocument: "PDF-Dokument",
        failedFetchPdf: "PDF konnte nicht abgerufen werden",
        importedVideo: "Importiertes Video",
        failedSpotifyImport: "Import von Spotify fehlgeschlagen",
        imagePreviewNotAvailable: "Bildvorschau nicht verfügbar",
        videoPreviewNotAvailable: "Videovorschau nicht verfügbar",
        scanningPdf: "PDF wird gescannt...",
        unknownVideo: "Unbekanntes Video",
        openInSpotify: "In Spotify öffnen",
        import: "Importieren",
        previewNotAvailable: "Vorschau nicht verfügbar",
        failedDownloadFile: "Datei-Download fehlgeschlagen: {status} {statusText}",
        downloadFailed: "Download fehlgeschlagen",
        downloading: "Wird heruntergeladen...",
        downloadFile: "Datei herunterladen",
        play: undefined,
        filterPlaylist: "Hauptliste nach dieser Playlist filtern",
        filtered: "gefiltert",
        clearFilter: "Filter löschen",
        openPlaylist: "Playlist öffnen",
        spotifyNotSupported: "Spotify nicht unterstützt",
        spotifyNotSupportedDescription: "Spotify-Wiedergabe wird im Browser auf iOS-Geräten aufgrund von Autoplay-Einschränkungen nicht unterstützt.",
        spotifyNotSupportedNote: "Bitte verwenden Sie die Spotify-App direkt für die Musikwiedergabe.",
        spotifyNotConnected: "Spotify nicht verbunden"
    },
    imageSelection: {
        title: "Bilder aus {title} auswählen",
        description: "Wählen Sie die Bilder aus, die Sie zu Ihrer Playlist hinzufügen möchten",
        loading: "Bilder werden geladen...",
        selected: "Ausgewählt",
        imagesSelected: "{count} von {total} Bildern ausgewählt",
        addImagesToPlaylist: {
            singular: "{count} Bild zur Playlist hinzufügen",
            plural: "{count} Bilder zur Playlist hinzufügen"
        },
        cancel: "Abbrechen",
        imageNotAvailable: "Bild nicht verfügbar",
        bibleIllustration: "Bibelillustration {number}",
        page: "Seite",
        of: "von",
        previous: "Zurück",
        next: "Weiter",
        showingImages: "Zeige {start}-{end} von {total} Bildern"
    },
    settings: {
        title: "Einstellungen",
        cloudStorage: "Material",
        cloudDesc: "Verbinden Sie einen Cloud-Anbieter, um auf Ihre Dateien und Ordner zuzugreifen.",
        connectSharepoint: "SharePoint verbinden",
        connectDrive: "Google Drive verbinden",
        connected: "Verbunden",
        disconnect: "Trennen",
        disconnectSharePoint: "SharePoint trennen",
        disconnectGoogleDrive: "Google Drive trennen",
        disconnectSpotify: "Spotify trennen",
        disconnectFirst: "Zuerst trennen",
        otherProviderConnected: "Anderer Anbieter verbunden",
        confirmDisconnect: "Sind Sie sicher, dass Sie die Verbindung trennen möchten? Der Zugriff auf Cloud-Dateien wird widerrufen und bestehende Playlists könnten beschädigt werden.",
        addBaseFolder: "Basis-Ordner hinzufügen",
        addBaseFolderDesc: "Konfigurieren Sie mehrere Basis-Ordner, um separate Dateiansichten in der Seitenleiste zu erstellen",
        menuTitle: "Menütitel",
        menuTitlePlaceholder: "Titel für Seitenleisten-Menü eingeben",
        addFirstBaseFolder: "Ersten Basis-Ordner hinzufügen",
        noBaseFoldersConfigured: "Keine Basis-Ordner konfiguriert",
        connecting: "Verbinden...",
        worshipSection: "Lobpreis",
        worshipDesc: "Verbinde dein Spotify Premium account für Songs. Diese Funktion erfordert Spotify Premium und kann nur in der Kirche aktiviert werden.",
        enableWorship: "Lobpreis-Modul aktivieren",
        youtubeIntegration: "YouTube Integration",
        addPlaylist: "Playlist ID hinzufügen",
        save: "Speichern",
        baseFolder: "Basis-Ordner für Medien",
        baseFolderDesc: "Wählen Sie den Ordner aus, der als Basis für Ihre Medien-Dateien und den Playlist-Builder verwendet werden soll.",
        setBaseFolderFirst: "Basis-Ordner zuerst festlegen",
        setBaseFolderFirstDesc: "Sie müssen zuerst einen Basis-Ordner festlegen, bevor Sie zusätzliche Sidebar-Ordner hinzufügen können. Die Sidebar-Ordner müssen sich innerhalb des Basis-Ordners befinden.",
        privacyWarning: "Datenschutz-Warnung",
        privacyWarningDesc: "Ihr Basis-Ordner ist auf das Stammverzeichnis gesetzt. Das bedeutet, dass der Datei-Index Zugriff auf ALLE Dateien und Ordner in Ihrem Cloud-Speicher hat. Wählen Sie einen spezifischeren Ordner für besseren Datenschutz.",
        change: "Ändern",
        remove: "Entfernen",
        selectFolder: "Ordner auswählen",
        disconnectConfirmTitle: "Verbindung trennen?",
        disconnectConfirmMessage: "Möchten Sie die Verbindung zu <strong>{provider}</strong> wirklich trennen?<br/><br/><strong>Achtung:</strong> Der Zugriff auf alle Cloud-Dateien geht verloren und bestehende Playlists funktionieren möglicherweise nicht mehr.",
        cancel: "Abbrechen",
        disconnectAction: "Trennen",
        folderPickerTitle: "Ordner auswählen",
        currentFolder: "Aktueller Ordner:",
        selectThisFolder: "Diesen Ordner wählen",
        folderEmpty: "Dieser Ordner ist leer oder enthält keine Unterordner.",
        enableWorshipDesc: "Enable or disable the Worship playlist module globally.",
        enableYoutube: "YouTube Modul aktivieren",
        enableSpotify: "Spotify Modul aktivieren",
        enableSlides: "Slides Modul aktivieren",
        enableYoutubeDesc: "Aktiviert die Integration von YouTube-Videos in Playlists.",
        enableSpotifyDesc: "Aktiviert die Integration von Spotify-Musik in Playlists.",
        indexingError: "Fehler beim Erstellen des Index",
        spotifyDisconnect: "Spotify-Verbindung konnte nicht getrennt werden",
        fileIndexing: "Dateien-Index",
        fileIndexingDesc: "Wenn aktiviert, wird die schnelle Suchfunktion aktiviert und ermöglicht das Durchsuchen aller Cloud-Dateien sofort.",
        enableFileIndexing: "Dateien-Index aktivieren",
        enableFileIndexingDesc: "Wenn aktiviert, wird ein durchsuchbarer Index aller Cloud-Dateien für schnellere Suche in Playlists erstellt",
        indexedDataInfo: "Informationen zu indizierten Daten",
        indexedDataDescription: "Folgenden Daten werden gespeichert:",
        indexedFields: {
            id: "Datei-ID vom Cloud-Anbieter",
            name: "Datei/Ordnername",
            path: "Dateipfad relativ zum Basisordner",
            type: "Dateityp",
            parentId: "Übergeordnete Ordner-ID",
            size: "Dateigröße in Bytes",
            modifiedAt: "Letztes Änderungsdatum",
            createdAt: "Datum der Indexierung",
            lastIndexed: "Letzter Zeitpunkt der Indexierung"
        },
        fileIndexingNote: "Wenn aktiviert, wird die schnelle Suchfunktion in Playlists aktiviert und ermöglicht das Durchsuchen aller Cloud-Dateien sofort.",
        searchIndexStatus: "Such-Index Status",
        noIndexCreated: "Noch kein Index erstellt",
        createIndex: "Index erstellen",
        rebuildIndex: "Index neu erstellen",
        building: "Erstelle...",
        buildingIndex: "Index wird erstellt...",
        filesIndexed: "Dateien indiziert",
        foldersScanned: "Ordner durchsucht",
        buildTime: "Erstellungszeit",
        lastUpdated: "Zuletzt aktualisiert:",
        indexed: "Indiziert",
        notconnected: "Nicht Verbunden",
        smartUpdate: "Smart Update",
        fullRebuild: "Vollständig",
        connectSpotify: "Spotify verbinden",
        spotifyDisconnectConfirmMessage: "Möchten Sie die Verbindung zu <strong>Spotify</strong> wirklich trennen?<br/><br/><strong>Achtung:</strong> Alle Spotify-Playlists und Songs werden deaktiviert und sind nicht mehr zugänglich.",
        spotifyPremiumRequired: "Spotify Premium für vollständige Funktionalität erforderlich",
        rateLimited: "Rate-Limit erreicht - versuchen Sie es in {minutes} Minuten erneut",
        rateLimitTooltip: "Um unsere Server zu schonen ist ein aktualisieren des Indexes nur in vorgegebenen abständen möglich."
    },
    playlist: {
        title: "Playlists verwalten",
        create: "Neue Playlist",
        edit: "Bearbeiten",
        name: "Playlist Name",
        date: "Datum",
        tabs: {
            worship: "Lobpreis Playliste",
            material: "Material Playliste"
        },
        order: "Ablauf",
        worshipFirst: "Lobpreis zuerst",
        materialFirst: "Material zuerst",
        offlineMode: "Offline verfügbar machen",
        downloading: "Wird zwischengespeichert...",
        searchYoutube: "YouTube durchsuchen oder URL einfügen",
        selectFolder: "Ordner auswählen",
        fileBrowser: "Dateimanager",
        selectedItems: "Ausgewählte Elemente",
        noItems: "Keine Elemente ausgewählt.",
        filterSource: "Quelle / Playlist",
        allSources: "Alle Quellen",
        sourceLibrary: "Meine Bibliothek",
        startPresentation: "Präsentieren",
        pastPlaylistsAvailable: "{count} vergangene Playlist{plural} verfügbar",
        showPast: "Vergangene anzeigen",
        hidePast: "Vergangene ausblenden"
    },
    presentation: {
        exit: "Präsentation beenden",
        next: "Weiter",
        prev: "Zurück",
        end: "Ende der Präsentation"
    },
    users: {
        title: "Benutzerverwaltung",
        user: "Benutzer",
        language: "Sprache",
        addUser: "Benutzer hinzufügen",
        editUser: "Benutzer bearbeiten",
        deleteUser: "Benutzer löschen",
        simulate: "Simulieren",
        filterChurch: "Nach Kirche filtern",
        allChurches: "Alle Kirchen",
        church: "Kirche",
        name: "Name",
        email: "E-Mail",
        save: "Benutzer speichern",
        cancel: "Abbrechen",
        changePass: "Passwort ändern",
        newPass: "Neues Passwort",
        password: "Passwort",
        newPassword: "Neues Passwort",
        newPasswordPlaceholder: "Neues Passwort (leer lassen, um aktuelles beizubehalten)",
        passwordPlaceholder: "Passwort wird per E-Mail gesendet",
        passwordHelpText: "Ein temporäres Passwort wird generiert und an die E-Mail-Adresse des Benutzers gesendet.",
        // Service Pin related translations
        servicePinRequired: "Service PIN erforderlich",
        servicePinRequiredDesc: "Um Benutzer {name} von {kirche} zu simulieren, geben Sie bitte die Service PIN für diese Kirche ein.",
        servicePin: "Service PIN",
        servicePinPlaceholder: "ABC123",
        simulateUser: "Benutzer simulieren",
        invalidServicePin: "Ungültige Service PIN",
        failedValidateServicePin: "Service PIN Validierung fehlgeschlagen",
        pleaseEnterServicePin: "Bitte geben Sie eine Service PIN ein",
        roles: {
            SUPER_ADMIN: "Super Admin",
            CHURCH_ADMIN: "Admin",
            EDITOR: "Editor",
            USER: "Benutzer"
        }
,
        roleInformation: "Rollen Informationen",
        roleExplanations: {
            CHURCH_ADMIN: "Kann Benutzer, Einstellungen und alle Inhalte für ihre Gemeinde verwalten.",
            EDITOR: "Kann Playlists und Inhalte erstellen und bearbeiten.",
            USER: "Kann Playlists anzeigen und präsentieren."
        }
    },
    churches: {
        title: "Kirchen",
        add: "Kirche hinzufügen",
        edit: "Kirche bearbeiten",
        name: "Name",
        address: "Adresse",
        save: "Speichern",
        enableWorship: "Lobpreis-Modul aktivieren",
        enableWorshipDesc: "Aktiviert das Lobpreis-Modul für diese Gemeinde.",
        enableMaterial: "Material/Mediathek-Modul aktivieren",
        enableMaterialDesc: "Aktiviert die Material- und Mediathek-Funktionen für diese Gemeinde."
    },
    footer: {
        copyright: "© {year} ChurchCast. Alle Rechte vorbehalten.",
        support: "Support",
        impressum: "Impressum",
        privacy: "Datenschutz",
        changelog: "Changelog"
    },
    common: {
        close: "Schließen",
        cancel: "Abbrechen",
        create: "Erstellen",
        delete: "Löschen",
        only: "nur",
        deletePlaylist: "Playlist löschen",
        deletePlaylistConfirm: "Sind Sie sicher, dass Sie \"{title}\" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
        error: "Fehler",
        errorOccurred: "Ein Fehler ist aufgetreten"
    },
    admin: {
        // Device Management translations
        deviceManagement: "Geräteverwaltung",
        manageDeviceConnections: "Verwalten Sie Android TV-Geräteverbindungen und -limits",
        deviceLimits: "Gerätelimits",
        deviceLimit: "Gerätelimit",
        devices: "Geräte",
        currentlyConnected: "Aktuell verbunden",
        pendingConnections: "Ausstehende Verbindungen",
        requested: "Angefordert",
        approve: "Genehmigen",
        reject: "Ablehnen",
        connectedDevices: "Verbundene Geräte",
        noDevicesConnected: "Noch keine Geräte verbunden",
        devicesWillAppear: "Geräte erscheinen hier, sobald sie sich über QR-Code verbinden",
        connected: "Verbunden",
        disconnect: "Trennen",
        setDeviceLimit: "Gerätelimit festlegen",
        setMaxDevicesDescription: "Legen Sie die maximale Anzahl von Geräten fest, die sich mit Ihrem Kirchenkonto verbinden können.",
        enterDeviceLimit: "Gerätelimit eingeben (1-100)",
        cancel: "Abbrechen",
        updateLimit: "Limit aktualisieren",
        // Error messages
        failedApproveDevice: "Gerät konnte nicht genehmigt werden",
        deviceRejectionNotImplemented: "Geräteablehnung noch nicht implementiert",
        confirmDisconnectDevice: "Sind Sie sicher, dass Sie dieses Gerät trennen möchten?",
        failedDisconnectDevice: "Gerät konnte nicht getrennt werden",
        invalidDeviceLimit: "Bitte geben Sie eine gültige Zahl zwischen 1 und 100 ein",
        failedUpdateDeviceLimit: "Gerätelimit konnte nicht aktualisiert werden",
        accessDenied: "Zugriff verweigert. Administratorrechte erforderlich."
    },
    logs: {
        totalLogs: "Gesamte LogView",
        errors: "Fehler",
        warnings: "Warnungen",
        info: "Info",
        level: "Level",
        source: "Quelle",
        userId: "Benutzer-ID",
        churchId: "Kirchen-ID",
        startDate: "Startdatum",
        endDate: "Enddatum",
        timestamp: "Zeitstempel",
        message: "Nachricht",
        user: "Benutzer",
        church: "Kirche",
        noLogs: "Keine LogView gefunden",
        exportLogs: "LogView exportieren",
        exportFormat: "Export-Format",
        cleanupLogs: "Alte LogView bereinigen",
        cleanupWarning: "Warnung",
        cleanupWarningDesc: "Diese Aktion wird dauerhaft LogView löschen, die älter als die angegebene Anzahl von Tagen sind. Dies kann nicht rückgängig gemacht werden.",
        keepDays: "LogView behalten für (Tage)",
        cleanupNow: "Jetzt bereinigen",
        showing: "Zeige",
        to: "bis",
        of: "von",
        entries: "Einträge",
        loading: "Wird geladen...",
        filter: "Filter",
        clear: "Alle löschen",
        all: "Alle",
        export: "Exportieren",
        cleanup: "Bereinigen",
        cancel: "Abbrechen",
        exporting: "Exportiere...",
        cleaning: "Bereinige..."
    },
    cookies: {
        title: "Cookies und Datenschutz",
        description: "Wir verwenden Cookies, um Ihnen die bestmögliche Erfahrung zu bieten. Die Cookies sind für die Grundfunktionen der Website erforderlich. Mit dem Login stimmen Sie der Verwendung von Cookies zu.",
        customize: "Anpassen",
        acceptAll: "Alle akzeptieren",
        rejectAll: "Alle ablehnen",
        preferences: "Cookie-Einstellungen",
        preferencesDescription: "Wählen Sie aus, welche Arten von Cookies Sie akzeptieren möchten. Sie können Ihre Auswahl jederzeit ändern.",
        necessary: "Notwendige Cookies",
        necessaryDescription: "Diese Cookies sind für die Grundfunktionen der Website erforderlich und können nicht deaktiviert werden.",
        functional: "Funktionale Cookies",
        functionalDescription: "Diese Cookies ermöglichen erweiterte Funktionen wie Personalisierung und können von uns oder Drittanbietern gesetzt werden.",
        analytics: "Analyse-Cookies",
        analyticsDescription: "Diese Cookies helfen uns zu verstehen, wie Besucher mit der Website interagieren, indem sie Informationen anonym sammeln und melden.",
        marketing: "Marketing-Cookies",
        marketingDescription: "Diese Cookies werden verwendet, um Besuchern relevante Werbung zu zeigen und die Effektivität von Werbekampagnen zu messen.",
        thirdPartyServices: "Drittanbieter-Services",
        youtubeService: "Wird für YouTube-Video-Integration verwendet",
        spotifyService: "Wird für Spotify-Musik-Integration verwendet",
        googleService: "Wird für Google Drive-Integration verwendet",
        sharepointService: "Wird für SharePoint-Integration verwendet",
        cancel: "Abbrechen",
        savePreferences: "Einstellungen speichern"
    },
    landing: {
        nav: {
            home: "Startseite",
            features: "Funktionen",
            benefits: "Vorteile",
            pricing: "Preise",
            contact: "Kontakt",
            login: "Anmelden"
        },
        hero: {
            title: "Moderne Medien mit {name} einfach nutzen!",
            subtitle: "Die moderne Plattform für Kinderkirche",
            ctaDemo: "Kostenlose Tour",
            ctaLearnMore: "Mehr erfahren"
        },
        overview: {
            title: "Wer steht hinter ChurchCast?",
            founderName: "Josua Barron",
            founderTitle: "Gründer von ChurchCast",
            founderDescription: "Als leidenschaftlicher Entwickler und Pastor habe ich ChurchCast ins Leben gerufen, um Kirchengemeinden dabei zu helfen, ihre Botschaft mit modernster Technik so einfach wie möglich zu verbreiten. Mit Erfahrung in der Softwareentwicklung und einem tiefen Verständnis für die Bedürfnisse von Gemeinden, schaffe ich Lösungen, die Tradition und Innovation nahtlos verbinden."
        },
        features: {
            title: "Hauptfunktionen",
            items: {
                preparation: {
                    title: "Vorbereitung",
                    description: "Church Cast unterstützt dich in einfachen Schritten bei der Vorbereitung deiner Kinderkirche"
                },
                presentation: {
                    title: "Live Präsentation", 
                    description: "Nahtlose Präsentation von Videos, Bildern, Audio und PDFs während der Kinderkirche"
                },
                worship: {
                    title: "Worship Management",
                    description: "Verwalten Sie Lieder und Playlists für die Kinderkirche. Integration mit Spotify und YouTube"
                },
                cloud: {
                    title: "Cloud Speicher",
                    description: "Sicherer verbindung zu ihrem Cloud-Speicher für alle Ihre Medien-Dateien mit automatischer Synchronisation"
                },
                multiUser: {
                    title: "Multi-User System",
                    description: "Verwalten Sie Berechtigungen für verschiedene Teammitglieder und Ehrenamtliche"
                }
            }
        },
        benefits: {
            title: "Warum ChurchCast wählen?",
            subtitle: "Die Vorteile, die den Unterschied machen",
            items: {
                timeSaving: {
                    title: "Zeitersparnis",
                    description: "Reduzieren Sie die Vorbereitungszeit mit unseren intelligenten Tool"
                },
                costEfficiency: {
                    title: "Kosteneffizienz", 
                    description: "Eine Lösung für alle Ihre Bedürfnisse - keine teuren Einzelplatzlizenzen mehr erforderlich"
                },
                easyUse: {
                    title: "Einfache Bedienung",
                    description: "Intuitive Benutzeroberfläche, die auch technisch weniger versierte Teammitglieder schnell beherrschen"
                }
            }
        },
        contact: {
            title: "Bereit für den nächsten Schritt?",
            subtitle: "Vereinbaren Sie eine kostenlose Tour oder kontaktieren Sie uns",
            email: {
                title: "E-Mail",
                address: "kontakt@josua-barron.de"
            },
            address: {
                title: "Adresse",
                lines: ["Reuther Straße 59B", "91301 Forchheim"]
            },
            form: {
                namePlaceholder: "Ihr Name",
                emailPlaceholder: "Ihre E-Mail", 
                churchPlaceholder: "Kirche",
                messagePlaceholder: "Ihre Nachricht",
                submitButton: "Nachricht senden",
                submitting: "Wird gesendet...",
                successMessage: "Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet.",
                errorMessage: "Entschuldigung, beim Senden Ihrer Nachricht ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
            }
        },
        footer: {
            tagline: "Eine moderne Lösung für digitale Kirche",
            productSection: "Produkt",
            supportSection: "Support",
            companySection: "Unternehmen",
            helpCenter: "Hilfe Center",
            aboutUs: "Über uns",
            privacy: "Datenschutz",
            copyright: "Alle Rechte vorbehalten."
        },
        floatingCards: {
            liveStreaming: "Presentation",
            worship: "Worship",
            community: "Kinderkirche"
        },
        pricing: {
            title: "ChurchCast Preise",
            setup: "Einmalige Einrichtung",
            monthly: "Pro aktives Gerät/Monat",
            description: "Flexible Preisgestaltung basierend auf der Anzahl der Geräte in Ihrer Kirche",
            includes: "Pakete beinhaltet:",
            features: [
                "Vorbereitung direkt aus dem Material",
                "Einfache Präsentation von Videos, Bildern, Audio und PDFs",
                "Spotify & Youtube Integration",
                "Multi-User Support"
            ],
            guarantee: {
                title: "30-Tage Geld-zurück-Garantie",
                description: "Testen Sie ChurchCast risikofrei. Wenn Sie innerhalb von 30 Tagen nicht zufrieden sind, erstatten wir Ihre Einrichtungsgebühr."
            },
            churchPlants: "Für Gründungen: Keine Einrichtungsgebühr, nur 5€/Monat pro Gerät im ersten Jahr.",
            requestDemo: "Demo anfordern"
        }
    },
    remote: {
        title: "Fernbedienung",
        back: "Zurück",
        play: "Abspielen/Pause",
        forward: "Vorwärts",
        notSet: "Nicht gesetzt",
        recorded: "Aufgenommen",
        help: "Klicke auf einen Button und drücke dann die Taste auf deiner Fernbedienung, die du zuweisen möchtest. Die Schaltfläche wird grün, wenn eine Taste hinterlegt ist."
    },
    tvLogin: {
        title: "TV Login",
        description: "Scannen Sie den QR-Code mit Ihrem Telefon zum Anmelden",
        generateQrCode: "QR-Code generieren",
        qrCodeExpired: "QR-Code ist abgelaufen",
        loginCancelled: "Anmeldung wurde abgebrochen",
        failedCheckLoginStatus: "Anmeldestatus konnte nicht geprüft werden",
    },
    qrDashboard: {
        title: "QR Dashboard",
        showHidden: "Vergangene anzeigen",
        hideHidden: "Vergangene ausblenden",
        noPlaylists: "Keine Playlists verfügbar",
        noPlaylistsHint: "Alle Playlists sind für zukünftige Termine geplant",
        enableHidden: '"Vergangene anzeigen" aktivieren, um ältere Playlists zu sehen',
        play: "Abspielen",
        items: "Einträge",
        scheduled: "Geplant",
        left: "Links",
        right: "Rechts",
        playKey: "Abspielen",
        playlistCount: "Playlists gesamt",
        logout: "Abmelden",
        selected: "Ausgewählt",
        playlists: "Playlists",
        description: "Scanne den QR-Code mit deinem Handy, um dich schnell anzumelden.",
        generateQrCode: "QR-Code generieren",
        generatingQrCode: "QR-Code wird generiert...",
        qrCodeExpired: "QR-Code ist abgelaufen. Bitte generiere einen neuen.",
        loginCancelled: "Anmeldung abgebrochen.",
        failedCheckLoginStatus: "Fehler beim Überprüfen des Anmeldestatus. Bitte versuche es erneut.",
        failedGenerateQrCode: "Fehler beim Generieren des QR-Codes. Bitte versuche es erneut.",
        scanWithPhone: "Mit Handy scannen",
        backToDashboard: "Zurück zum Dashboard",
        accessDenied: "Zugriff verweigert",
        accessDeniedMessage: "Diese Seite ist nur für Zuschauer verfügbar. Bitte verwende die reguläre Anmeldeseite.",
        sessionExpired: "Sitzung abgelaufen. Bitte versuche es erneut."
    },
    qrLogin: {
        title: "Sitzung authentifizieren",
        sessionExpiresIn: "Sitzung läuft ab in:",
        qrSessionExpired: "QR-Code-Sitzung ist abgelaufen. Bitte scannen Sie einen neuen QR-Code.",
        emailRequired: "E-Mail ist erforderlich",
        passwordRequired: "Passwort ist erforderlich",
        invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
        loginFailed: "Anmeldung fehlgeschlagen",
        networkError: "Netzwerkfehler. Bitte versuchen Sie es erneut.",
        emailPlaceholder: "Geben Sie Ihre E-Mail ein",
        passwordPlaceholder: "Geben Sie Ihr Passwort ein",
        successMessage: "Sitzung erfolgreich authentifiziert! Weiterleitung...",
        authenticateButton: "Authentifizieren"
    }
};